module.exports = __webpack_public_path__ + "static/media/cover_page.0b44004d.png";